export function replaceText (text, item, encode) {
  const keys = Object.keys(item)
  for (let i = 0; i < keys.length; i++) {
    const tempKey = keys[i]
    const matchText = '{' + tempKey + '}'
    const index = text.indexOf(matchText)
    if (index >= 0) {
      if (encode === true) {
        text = text.replace(matchText, encodeURIComponent(item[tempKey]))
      } else {
        text = text.replace(matchText, item[tempKey])
      }
    }
  }
  return text
}



// WEBPACK FOOTER //
// ./src/libs/LinkUtil.js